!function(w,o,s,r,p,k,e){if(w.mkq){return}p=w.mkq=function(){p.invokeFunc?p.invokeFunc.apply(p,arguments):p.qu.push(arguments)};if(!w._mkq){w._mkq=p}p.push=p;p.qu=[];k=o.createElement(s);k.async=!0;k.src=r;e=o.getElementsByTagName(s)[0];e.parentNode.insertBefore(k,e)}(window,document,"script","//pixeltrack.clientgear.com/mkq.min.js");
  mkq('init', '42487381192193');
  mkq('track', 'PageView');

(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"134626874"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");



// (function() {
//         var ta = document.createElement('script'); ta.type = 'text/javascript'; ta.async = true;
//         ta.src = 'https://analytics.tiktok.com/i18n/pixel/sdk.js?sdkid=BUVHO2ID4EIVEV2IIAH0';
//         var s = document.getElementsByTagName('script')[0];
//         s.parentNode.insertBefore(ta, s);
// })();

try{
  var recommdivoffset = 0;
if($(".product-recommendations").length > 0){
	recommdivoffset = $(".product-recommendations").offset().top;
}

var bttopbtn = $("#bttop-button");

$(window).scroll((function() {
	if(recommdivoffset > 0){
	 	$(window).scrollTop() > (recommdivoffset - $(window).height()) ? bttopbtn.addClass("show") : bttopbtn.removeClass("show");
	}else{
		$(document).height() - $(window).scrollTop() - $(window).height() < 1200 ? bttopbtn.addClass("show") : bttopbtn.removeClass("show")
	}
    
})),
        bttopbtn.on("click", (function(e) {
            e.preventDefault(),
                $("html, body").animate({
                        scrollTop: 0
                    },
                    "300")
        }))
}catch(e){
  console.log(e)
}
